/**
 * Detect Free-plan walls so the UI can send the user to pay and continue.
 */

/**
 * Parse JSON from an axios error, including blob download responses.
 *
 * @param {Error} error
 * @returns {Promise<Object>}
 */
export async function getErrorPayload(error) {
  const data = error?.response?.data;
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      return JSON.parse(await data.text());
    } catch {
      return {};
    }
  }
  if (data && typeof data === 'object') {
    return data;
  }
  return {};
}

/**
 * True when the API is asking the visitor to upgrade (quota used up).
 *
 * @param {Object} payload
 * @returns {boolean}
 */
export function isPlanLimitPayload(payload) {
  const code = String(payload?.error_code || '');
  return code.startsWith('plan_limit');
}
